import { Button, Center, Dialog, Text, VStack } from '@chakra-ui/react';
import { useAppSelector } from '@hooks/redux.hooks';
import { useInactivityTimer } from '@hooks/useInactivityTimer';
import { selectIsInactiveAt } from '@redux/global/global.selector';
import { FormattedMessage } from 'react-intl';

type Props = {
  inactivityLimit: number;
};

export default function InactivityModal({ inactivityLimit }: Readonly<Props>) {
  const isInactiveAt = useAppSelector(selectIsInactiveAt);

  const resetInactivityTimer = useInactivityTimer({ inactivityLimit });
  return (
    <Dialog.Root
      open={isInactiveAt !== null}
      placement="center"
      closeOnEscape={false}
      closeOnInteractOutside={false}
      onOpenChange={resetInactivityTimer}
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Center backgroundColor="neutral.700" padding={4}>
            <VStack width="100%" gap={3}>
              <Text textAlign="center">
                <FormattedMessage id="authent.inactivityMessage" values={{ minutes: inactivityLimit }} />
              </Text>
              <Button width="max-content" onClick={resetInactivityTimer}>
                <FormattedMessage id="authent.isActive" />
              </Button>
            </VStack>
          </Center>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
